import React, { PropTypes } from "react";
import DependentsDataTable from "./DependentsDataTable";
import DependentsNav from "./DependentsNav";
import { connect } from "react-redux";

class DependentsPage extends React.Component {
  render() {
    return (
      <div className="sub-container">
        <DependentsNav
          clientId={this.props.clientId}
          memberId={this.props.memberId}
          dependentId={this.props.dependentId}
        />
        <div className="sub-content">
          {this.props.children || <DependentsDataTable />}
        </div>
      </div>
    );
  }
}

DependentsPage.propTypes = {
  clientId: PropTypes.string,
  dependentId: PropTypes.string,
  memberId: PropTypes.string,
  children: PropTypes.node,
};

function mapStateToProps(state, ownProps) {
  return {
    memberId: ownProps.params.memberId,
    clientId: ownProps.params.clientId,
    dependentId: ownProps.params.dependentId,
  };
}

export default connect(mapStateToProps)(DependentsPage);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/members/member/dependents/DependentsPage.js